import { render, staticRenderFns } from "./ContentPicker.vue?vue&type=template&id=3c2fd980&"
import script from "./ContentPicker.vue?vue&type=script&lang=js&"
export * from "./ContentPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports